import { reportConfig } from '../../../utils/config/tableReportConfig';
import getChartType from '../../../utils/helpers/getChartType';
import { getDynamicSelectData } from '../../../utils/api/data';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import React, {useState, useEffect} from 'react';
import { Button } from '@mui/material';
import FileDownload from 'js-file-download';
import './audit.css';
import Papa from 'papaparse';
import Cookies from 'js-cookie';
import Axios from 'axios';
import { config as customConfig } from "../../../config/Constants";


const Audit = () => {
  const [nrsStatus, setNrsStatus] = useState(null);
  const [auditSummary, setAuditSummary] = useState(null);
  const [accuracyChart, setAccuracyChart] = useState(null);
  const [auditDownload, setAuditDownload] = useState(null);

  const getData = async(config, setState, processData) => {
    if (Cookies.get('cp-cn') !== 'GTMS-CP') {
      const response = await getDynamicSelectData({
        selectValues: config.selectValues,
        tableName: config.tableName,
        whereField: config.whereField,
        whereOperators: config.whereOperators,
        whereValue: config.getWhereValue(),
        orderBy: config.orderBy,
        db: config.db,
      });
      const data = processData ? processData(response) : response;
      setState({ data });
    }
    if (Cookies.get('cp-cn') === 'GTMS-CP') {
      const response = await Axios.get(customConfig.url.GET_REPORT, {
      params: {
        reportName: 'parcelaudit',
        companyName: Cookies.get("cp-cn"),
      },
      });
      setState({data: response.data.report})
    };
  };

  useEffect(() => {
    getData(
      reportConfig['audit net rate'],
      setNrsStatus,
      response => response.map(row => ({nrs_status: row.ERROR_STATUS}))
    );

    getData(
      reportConfig['audit summary'],
      setAuditSummary,
      response => response.map(row => ({ 
        audit_percent: row.CORRECT_AUDIT_PERCENT,
        incorrect_audit_percent: row.INCORRECT_AUDIT_PERCENT,
        charge_amount: row.CHARGE_AMOUNT, 
        contract_amount: row.CONTRACT_AMOUNT, 
        overbilled: row.OVERBILLED 
      }))
    );

    getData(
      reportConfig['audit download'],
      setAuditDownload
    )
  }, []);

  useEffect(() => {
    if (!auditSummary?.data?.[0]?.audit_percent) return;

    const getChartComponent = async () => {
      const returnChart = await getChartType({
        data: [
          {PERCENTAGE: auditSummary.data[0].audit_percent, LABEL: 'CORRECTLY BILLED'}, 
          {PERCENTAGE: auditSummary.data[0].incorrect_audit_percent, LABEL: 'OVERBILLED' }
        ],
        centerValue: {value: auditSummary.data[0].audit_percent + '%' },
        chartInfo: [{ TYPE: 'DOUGHNUT' }],
      });
      setAccuracyChart(returnChart);
    };
    getChartComponent();
  }, [auditSummary]); 

  const year = new Date().getFullYear();
  const statusMap = {
    1: {
      text: `Thanks for providing your ${year} Net Rate Sheets.`,
      color: "#1e4263"
    },
    2: {
      text: `GTMS needs your ${year} Net Rate Sheets for the rate audit.`,
      color: "#c62828"
    },
    3: {
      text: "GTMS needs your current contract to audit accessorial charges.",
      color: "red"
    }
};

const status = nrsStatus?.data?.[0]?.nrs_status;
const statusInfo = statusMap[status] || { text: "Awaiting status update.", color: "gray" };

const handleDownload = () => {
    const csv = Papa.unparse(auditDownload);
    FileDownload(csv, `parcel-audit-${Date.now()}.csv`);
}

  return (
    <div className='auditPage'>
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
        <div className="auditPageContent">
          <div className="auditTitle">
            <h1>Parcel Audit</h1>
          </div>
          <div className="reportContainer">
            <div className="leftAudit">
              <div className="auditLineGraph">
                {accuracyChart}
              </div>
            </div>
            <div className="rightAudit">
              <div className="auditInformation">
                <div className="auditRow">
                  <h4>Charge Amount:</h4>
                  <h1>{auditSummary ? auditSummary.data[0].charge_amount : 'Loading...'}</h1>
                </div>
                <div className="auditRow">
                  <h4>Contract Amount:</h4>
                  <h1>{auditSummary ? auditSummary.data[0].contract_amount : 'Loading...'}</h1>
                </div>
                <div className="auditRow">
                  <h4>Over Billed:</h4>
                  <h1>{auditSummary ? auditSummary.data[0].overbilled : 'Loading...'}</h1>
                </div>
              </div>
              <div className="auditStatus">
                <div className="auditSubTitle">
                  <h3>Status Window:</h3>
                    <p style={{ color: statusInfo.color }}>
                      {statusInfo.text}
                    </p>
                </div>
              </div>
              <div className="downloadAudit">
                <Button
                  variant="contained"
                  fullWidth
                  sx={{ backgroundColor: "#1e4263", '&:hover': { backgroundColor: '#16354f' } }}
                  onClick={handleDownload}
                >
                  DOWNLOAD (Last 180 Days)
                </Button>
              </div>
            </div>
            <div className="auditReportBar"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Audit